import { formatExpirationLabel } from '@/lib/heatmapTable.utils';

interface DashboardHeatmapHeaderProps {
  expirations: readonly string[];
  timeSpentLabel: string | null;
}

const HEADER_CELL_CLASS_NAME =
  'sticky top-0 z-[5] h-[46px] border-b border-line bg-panel p-0 text-[13px] font-medium text-fg';

export function DashboardHeatmapHeader({
  expirations,
  timeSpentLabel,
}: DashboardHeatmapHeaderProps) {
  return (
    <thead>
      <tr>
        <th
          className={`${HEADER_CELL_CLASS_NAME} pl-2.5 text-left max-[720px]:left-0 max-[720px]:z-[6]`}
        >
          Strike
        </th>
        {expirations.map((expiration) => (
          <th
            key={expiration}
            className={`${HEADER_CELL_CLASS_NAME} border-l border-l-line text-center`}
          >
            {formatExpirationLabel(expiration)}
          </th>
        ))}
        {timeSpentLabel != null && (
          <th className={`${HEADER_CELL_CLASS_NAME} pl-2.5 text-left`}>
            <div className="flex flex-col items-start justify-center gap-[3px]">
              <span className="whitespace-nowrap text-xs font-semibold tracking-[0.02em]">
                TIME SPENT %
              </span>
              <span className="text-xs font-normal text-subtle">({timeSpentLabel})</span>
            </div>
          </th>
        )}
      </tr>
    </thead>
  );
}
